var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.768,
    height: 7.884,
    viewBox: "0 0 12.768 7.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-expand-more",
    "data-name": "Icon material-expand-more",
    d: "M20.268,12.885l-4.884,4.873L10.5,12.885,9,14.385l6.384,6.384,6.384-6.384Z",
    transform: "translate(-9 -12.885)",
    fill: "#b2b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c2e5e386b8691a1b9ac68aae21833b4c.svg";
export { ForwardRef as ReactComponent };